

const money = (amountMinor, currency = "BRL") => ({ amountMinor, currency });

export const MOCK_OWNER_COMPANY_ID = "mock-owner-1001";

export const mockEntitlementEnabled = {
  ownerCompanyId: MOCK_OWNER_COMPANY_ID,
  enabled: true,
  version: 1,
  updatedAt: "2026-10-01T12:00:00.000Z",
};

export const mockEntitlementDisabled = {
  ownerCompanyId: MOCK_OWNER_COMPANY_ID,
  enabled: false,
  version: 0,
  updatedAt: null,
};

export const mockSummary = {
  asOf: new Date().toISOString(),
  currency: "BRL",
  totalBreakageAmount: money(158750),
  breakdown: {
    eligibleRemainingAmount: money(158750),
    identifiedAmount: money(42000),
    executedAmount: money(0),
  },
};

export const mockBalanceLots = [
  {
    balanceLotId: "11111111-1111-1111-1111-111111111111",
    sourceTransactionId: "stx-9001",
    participantId: "163",
    accountId: "acc-163",
    financialBalanceScopeId: "fbs-1",
    ownerCompanyId: MOCK_OWNER_COMPANY_ID,
    originalAmount: money(10000),
    consumedAmount: money(2500),
    remainingAmount: money(7500),
    creditedAt: "2026-07-10T14:22:00.000Z",
    expiresAt: "2026-10-08T23:59:59.000Z",
    originType: "SOLICITATION",
    ownerResolutionStatus: "RESOLVED",
    breakageIneligibilityReason: null,
    eligibility: "ELIGIBLE",
    consumptionCondition: "PARTIAL",
    agingCondition: "EXPIRED",
    ownerResolutionEvidence: [],
    participant: {
      kind: "NaturalPerson",
      legalName: "Ana Souza",
      documentNumber: "52998224725",
    },
  },
  {
    balanceLotId: "22222222-2222-2222-2222-222222222222",
    sourceTransactionId: "stx-9002",
    participantId: "204",
    accountId: "acc-204",
    financialBalanceScopeId: "fbs-1",
    ownerCompanyId: MOCK_OWNER_COMPANY_ID,
    originalAmount: money(25000),
    consumedAmount: money(0),
    remainingAmount: money(25000),
    creditedAt: "2026-08-01T09:00:00.000Z",
    expiresAt: "2026-10-15T23:59:59.000Z",
    originType: "SOLICITATION",
    ownerResolutionStatus: "RESOLVED",
    breakageIneligibilityReason: null,
    eligibility: "ELIGIBLE",
    consumptionCondition: "NONE",
    agingCondition: "WITHIN_WINDOW",
    ownerResolutionEvidence: [],
    participant: {
      kind: "NaturalPerson",
      legalName: "Bruno Costa Lima",
      documentNumber: "39053344705",
    },
  },
  {
    balanceLotId: "33333333-3333-3333-3333-333333333333",
    sourceTransactionId: "stx-9003",
    participantId: "318",
    accountId: "acc-318",
    financialBalanceScopeId: "fbs-1",
    ownerCompanyId: MOCK_OWNER_COMPANY_ID,
    originalAmount: money(50000),
    consumedAmount: money(50000),
    remainingAmount: money(0),
    creditedAt: "2026-06-20T11:30:00.000Z",
    expiresAt: "2026-09-20T23:59:59.000Z",
    originType: "TRANSFER",
    ownerResolutionStatus: "RESOLVED",
    breakageIneligibilityReason: null,
    eligibility: "ELIGIBLE",
    consumptionCondition: "FULL",
    agingCondition: "EXPIRED",
    ownerResolutionEvidence: [],
    participant: {
      kind: "NaturalPerson",
      legalName: "Carla Mendes",
      documentNumber: "11144477735",
    },
  },
  {
    balanceLotId: "44444444-4444-4444-4444-444444444444",
    sourceTransactionId: "stx-9004",
    participantId: "401",
    accountId: "acc-401",
    financialBalanceScopeId: "fbs-1",
    ownerCompanyId: MOCK_OWNER_COMPANY_ID,
    originalAmount: money(8000),
    consumedAmount: money(0),
    remainingAmount: money(8000),
    creditedAt: "2026-09-01T16:45:00.000Z",
    expiresAt: "2026-12-01T23:59:59.000Z",
    originType: "FUNDS_IN",
    ownerResolutionStatus: "RESOLVED",
    breakageIneligibilityReason: "FUNDS_IN_EXEMPT",
    eligibility: "INELIGIBLE",
    consumptionCondition: "NONE",
    agingCondition: "WITHIN_WINDOW",
    ownerResolutionEvidence: [],
    participant: {
      kind: "Organization",
      legalName: "Delta Comercio Ltda",
      documentNumber: "04252011000110",
    },
  },
  {
    balanceLotId: "55555555-5555-5555-5555-555555555555",
    sourceTransactionId: "stx-9005",
    participantId: "512",
    accountId: "acc-512",
    financialBalanceScopeId: "fbs-1",
    ownerCompanyId: MOCK_OWNER_COMPANY_ID,
    originalAmount: money(15750),
    consumedAmount: money(0),
    remainingAmount: money(15750),
    creditedAt: "2026-09-15T08:10:00.000Z",
    expiresAt: "2026-10-08T12:00:00.000Z",
    originType: "SOLICITATION",
    ownerResolutionStatus: "RESOLVED",
    breakageIneligibilityReason: null,
    eligibility: "ELIGIBLE",
    consumptionCondition: "NONE",
    agingCondition: "EXPIRED",
    ownerResolutionEvidence: [
      {
        bootstrapRunId: "boot-1",
        resolvedAt: "2026-09-15T08:11:00.000Z",
        status: "RESOLVED",
        ownerCompanyId: MOCK_OWNER_COMPANY_ID,
      },
    ],
    participant: {
      kind: "NaturalPerson",
      legalName: "Tiago Oliveira",
      documentNumber: "39053344705",
    },
  },
];

export const paginateMock = (items, { limit = 10, cursor } = {}) => {
  const start = cursor ? Number(cursor) || 0 : 0;
  const pageItems = items.slice(start, start + limit);
  const next = start + limit;
  const hasMore = next < items.length;
  return {
    items: pageItems,
    page: {
      limit,
      hasMore,
      nextCursor: hasMore ? String(next) : null,
    },
  };
};
